/**
 *拼接url参数
 *
 * @param {*} link
 * @param {*} params
 * @returns url
 */
function concatURI(link, params) {
    const query = []
    params.forEach(item => {
        let val = item.val
        if (val) {
            if (typeof item.val === 'object') {
                val = encodeURIComponent(JSON.stringify(item.val))
            } else {
                val = encodeURIComponent(val)
            }
            query.push(`${item.key}=${val}`)
        }
    })
    return link + (link.includes('?') ? '&' : '?') + query.join('&')
}
function throttle(func, delay) {
    let timer = null
    return event => {
        if (!timer) {
            timer = setTimeout(function() {
                func.call(this, event)
                timer = null
            }, delay)
        }
    }
}
function debounce(fn, wait) {
    let timeout = null
    return event => {
        if (timeout !== null) clearTimeout(timeout)
        timeout = setTimeout(fn.bind(this, event), wait)
    }
}
function sleep(time) {
    return new Promise((resolve, reject) => {
        setTimeout(resolve, time)
    })
}
function isObject(s) {
    return Object.prototype.toString.call(s) === '[object Object]'
}
/**
 *生成随机id
 *
 * @param {number} [length=5]
 * @returns
 */
function genId(length = 5) {
    return Number(
        Math.random()
            .toString()
            .substr(3, length) + Date.now()
    ).toString(36)
}
function addComma(value, splitNum = 3) {
    const valueType = typeof value
    if (!['number', 'string'].includes(valueType)) return value
    const pointsArr = value.toString().split(''),
        res = pointsArr.slice()
    for (let i = pointsArr.length - splitNum - 1; i >= 0; i -= splitNum) {
        res.splice(i + 1, 0, ',')
    }
    return res.join('')
}
/**
 *以‘-’拼接
 *
 * @param {*} arr[string]
 * @returns
 */
function concatWithDashLine(...arr) {
    let res = '',
        lastChar = ''
    arr.forEach(t => {
        if (t) {
            lastChar = res.charAt(res.length - 1)
            if (lastChar && lastChar != '-') {
                res += '-' + t
            } else {
                res += t
            }
        }
    })
    return res
}
function isFullURI(url) {
    try {
        return /^http/.test(url)
    } catch (error) {
        return false
    }
}
export {
    concatURI,
    throttle,
    debounce,
    isObject,
    sleep,
    genId,
    addComma,
    concatWithDashLine,
    isFullURI
}
